// "Show ARV" support for the I-chart (Colonial request).
//
// ARV = the user-defined average from the key's Control Strategy configuration
// (`mean`, UI row "Mean"; default 'N/A'). When the toggle is on, an EXTRA
// constant line is drawn at the ARV (dark blue, dashed) alongside the calculated
// Center Line, which stays exactly as it was (the average). Control limits,
// EWMA limits and flags are NOT re-centred — they stay calculated.

export const ARV_DATA_KEY = 'arvLine';
export const ARV_LINE_NAME = 'ARV';
// Dashed dark blue, 2px — matches the reference mock-up supplied with the request
// (measured: rgb(0,0,204), 2px thick, ~10px dashes with ~9px gaps).
export const ARV_LINE_COLOR = '#0000CC';
export const ARV_LINE_DASHARRAY = '10 9';
export const ARV_LINE_STROKE_WIDTH = 2;
const CENTER_LINE_Y_AXIS = 'mean';

// Returns the ARV as a finite number, or null when it is N/A / blank / non-numeric.
export const parseArvValue = (arv) => {
  if (arv === null || arv === undefined) return null;
  if (typeof arv === 'number') return Number.isFinite(arv) ? arv : null;
  const trimmed = String(arv).trim();
  if (trimmed === '') return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
};

const isCenterLine = (line) => line?.yAxis === CENTER_LINE_Y_AXIS;

export const hasCenterLine = (lines) => Array.isArray(lines) && lines.some(isCenterLine);

// Add a constant ARV line right after the Center Line (which is kept as-is).
// Each data row gets the ARV under ARV_DATA_KEY so the line plots flat and the
// tooltip reads "ARV : value". `legendType: 'plainline'` makes the legend swatch
// render dashed too. If the center line carries a visible label, the ARV label is
// placed top-left so the two don't overlap when the values are close.
export const addArvLine = (lines = [], data = [], arvValue) => {
  const safeLines = lines || [];
  const centerIndex = safeLines.findIndex(isCenterLine);
  if (centerIndex === -1) return { lines: safeLines, data };
  const centerLine = safeLines[centerIndex];
  const arvLine = {
    yAxis: ARV_DATA_KEY,
    name: ARV_LINE_NAME,
    reference: centerLine.reference,
    label: centerLine.label ? { value: ARV_LINE_NAME, position: 'insideTopLeft' } : '',
    color: ARV_LINE_COLOR,
    strokeDasharray: ARV_LINE_DASHARRAY,
    strokeWidth: ARV_LINE_STROKE_WIDTH,
    legendType: 'plainline',
    overrideValue: arvValue
  };
  return {
    lines: [...safeLines.slice(0, centerIndex + 1), arvLine, ...safeLines.slice(centerIndex + 1)],
    data: (data || []).map((row) => ({ ...row, [ARV_DATA_KEY]: arvValue }))
  };
};
